<template>
    <admin-layout>
        <template #header>
            <h2 class="text-xl font-semibold leading-tight text-white">
                Dashboard
            </h2>
        </template>
        <div class="py-12">
            <div class="flex flex-wrap mx-auto max-w-7xl sm:px-6 lg:px-8">
                <!-- students -->
                <div class="w-4/12 p-4 mb-4 text-center text-white hover:text-pink-600">
                    <inertia-link :href="route('students')">
                        <span class="font-bold text-8xl">{{ students }}</span>
                        <h3 class="text-center">Clienti Registrati</h3>
                    </inertia-link>
                </div>
                <!-- prizes -->
                <div class="w-4/12 p-4 mb-4 text-center text-white hover:text-pink-600">
                    <inertia-link :href="route('prizes')">
                        <span class="font-bold text-8xl">{{ prizes }}</span>
                        <h3 class="text-center">Premi raggiunti</h3>
                    </inertia-link>
                </div>
                <!-- contacts -->
                <div class="w-4/12 p-4 mb-4 text-center text-white hover:text-pink-600">
                    <inertia-link :href="route('contacts')">
                        <span class="font-bold text-8xl">{{ contacts }}</span>
                        <h3 class="text-center">Contatti ricevuti</h3>
                    </inertia-link>
                </div>
                <!-- tickets -->
                <div class="w-4/12 p-4 mb-4 text-center text-white hover:text-pink-600">
                    <inertia-link :href="route('tickets')">
                        <span class="font-bold text-8xl">{{ iosm }}</span>
                        <h3 class="text-center">Open ticket iOSM</h3>
                    </inertia-link>
                </div>
                <!-- promos -->
                <div class="w-4/12 p-4 mb-4 text-center text-white hover:text-pink-600">
                    <inertia-link :href="route('promos')">
                        <span class="font-bold text-8xl">{{ promos }}</span>
                        <h3 class="text-center">Codici Promo ricevuti</h3>
                    </inertia-link>
                </div>
                <!-- asks -->
                <div class="w-4/12 p-4 mb-4 text-center text-white hover:text-pink-600">
                    <inertia-link :href="route('asks')">
                        <span v-if="asks > 0" class="font-bold text-green-400 text-8xl">{{ asks }}</span>
                        <span v-else class="font-bold text-white text-8xl">{{ asks }}</span>
                        <h3 class="text-center">Richieste OSM Coin</h3>
                    </inertia-link>
                </div>
                <!-- students -->
                <div class="w-4/12 p-4 mb-4 text-center text-white hover:text-pink-600">
                    <inertia-link :href="route('students')">
                        <span class="font-bold text-8xl">{{ qrs }}</span>
                        <h3 class="text-center">QR Code caricati</h3>
                    </inertia-link>
                </div>
                <!-- missing qr -->
                <div class="w-4/12 p-4 mb-4 text-center text-white hover:text-pink-600">
                    <inertia-link :href="route('nocode')">
                        <span class="font-bold text-8xl">{{ noqr }}</span>
                        <h3 class="text-center">QR mancanti</h3>
                    </inertia-link>
                </div>
                <!-- last week user -->
                <div class="w-4/12 p-4 mb-4 text-center text-white hover:text-pink-600">
                    <inertia-link :href="route('students')">
                        <span class="font-bold text-8xl">{{ lastWeekNewUser }}</span>
                        <h3 class="text-center">nuovi utenti nell'ultima settimana</h3>
                    </inertia-link>
                </div>
            </div>
        </div>
        <div class="flex flex-wrap mx-auto max-w-7xl sm:px-6 lg:px-8">
            <div class="w-6/12 p-2 border border-white border-solid rounded-md">
                <h3 class="text-xl font-bold text-white">Assegnazione OSM Coin</h3>
                <p class="text-white">inserisci gli indirizzi email separati da virgole e senza spazi.</p>
                <form @submit.prevent="massivePrize">
                    <input id="emailaddress" type="email" name="emailaddress" v-model="emailaddress" class="w-full h-10 mb-1 rounded-md" multiple placeholder="email@email.com,email@email.com">
                    <div class="flex w-full">
                        <input type="text" v-model="gemmotive" class="w-6/12 p-2 mr-1 rounded-md" placeholder="motivo">
                        <input type="number" v-model="gemnumber" class="w-6/12 p-2 ml-1 rounded-md" min="1" max="100" placeholder="1">
                    </div>
                    <button type="submit" class="w-full p-2 my-2 text-center text-white bg-green-600 rounded-md shadow-md hover:bg-blue-600">invia</button>
                </form>
            </div>
        </div>
    </admin-layout>
</template>

<script>
    import AdminLayout from '@/Layouts/AdminLayout'

    export default {
        props: [ 'students', 'prizes', 'contacts', 'iosm', 'promos', 'asks', 'qrs', 'noqr', 'lastWeekNewUser'],
        components: {
            AdminLayout,
        },
        data() {
            return {
                emailaddress: this.emailaddress,
                gemmotive: this.gemmotive,
                gemnumber: this.gemnumber
            };
        },
        methods: {
            massivePrize() {
                const data = new FormData()
                data.append('emailaddress', this.emailaddress);
                data.append('gemmotive', this.gemmotive);
                data.append('gemnumber', this.gemnumber);

                this.$inertia.post(this.route('massiveupdate'), data, {
                onStart: () => this.sending = true,
                onFinish: () => this.sending = false,
                })
            }
        }
    }
</script>